import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=660ea88c&scoped=true"
var script = {}
import style0 from "./detail.vue?vue&type=style&index=0&id=660ea88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ea88c",
  null
  
)

export default component.exports